module.exports = __webpack_public_path__ + "images/create-first-board/card-drag/nb-card-drag.18c709f90d09fabe0450.gif";